import {
    SynopticTemplateNodeChildrenSelectionType,
    SynopticTemplateNodeType
} from '@/modules/configurationModule/detail/templates/synoptic-templates/services/configuration-synoptic-template/configuration-synoptic-template.dto'

export const nodeTypeTranslations: Record<SynopticTemplateNodeType, string> = {
    [SynopticTemplateNodeType.TITLE]: 'configuration.modal.synopticTemplate.none',
    [SynopticTemplateNodeType.VARIABLE_TEXT]: 'configuration.modal.synopticTemplate.freeText',
    [SynopticTemplateNodeType.VARIABLE_NUMBER]: 'configuration.modal.synopticTemplate.number',
    [SynopticTemplateNodeType.VARIABLE_DATE]: 'configuration.modal.synopticTemplate.date',
    [SynopticTemplateNodeType.VARIABLE_PERCENTAGE]: 'configuration.modal.synopticTemplate.percentage',
    [SynopticTemplateNodeType.VARIABLE_IMAGE]: 'configuration.modal.synopticTemplate.image'
}

export const nodeChildrenSelectionTypeTranslations: Record<SynopticTemplateNodeChildrenSelectionType, string> = {
    [SynopticTemplateNodeChildrenSelectionType.NONE]: 'configuration.modal.synopticTemplate.none',
    [SynopticTemplateNodeChildrenSelectionType.SINGLE_SELECTION]: 'configuration.modal.synopticTemplate.simpleSelection',
    [SynopticTemplateNodeChildrenSelectionType.MULTIPLE_SELECTION]: 'configuration.modal.synopticTemplate.multipleSelection'
}

export interface SynopticTemplatesModalStructureFormState {
    title: string
    nodeType: SynopticTemplateNodeType
    nodeChildrenSelectionType: SynopticTemplateNodeChildrenSelectionType
    code: string
    required: boolean
}
export const initialSynopticTemplatesModalStructureFormState =
    (): SynopticTemplatesModalStructureFormState => ({
        title: '',
        nodeType: SynopticTemplateNodeType.TITLE,
        nodeChildrenSelectionType: SynopticTemplateNodeChildrenSelectionType.NONE,
        code: '',
        required: false
    })
